<template>
  <div class="search-bar">
    <form class="search-form" @submit.prevent="emitSearch">
      <label class="search-label" :for="inputId">搜索文章</label>
      <input
        :id="inputId"
        type="search"
        :placeholder="placeholder"
        :value="localKeyword"
        @input="handleInput"
        aria-label="搜索文章"
      />
      <button type="submit">搜索</button>
    </form>
    <div v-if="hasSuggestions" class="search-suggestions">
      <button
        v-for="(item, index) in suggestions"
        :key="item + index"
        type="button"
        class="suggestion"
        :style="suggestionStyle(index)"
        @click="selectSuggestion(item)"
      >
        {{ item }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'search-bar',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '搜索文章标题、摘要或标签'
    },
    suggestions: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      localKeyword: this.value || '',
      inputId: `search-input-${this._uid}`
    }
  },
  computed: {
    hasSuggestions () {
      return Array.isArray(this.suggestions) && this.suggestions.length > 0
    }
  },
  watch: {
    value (newVal) {
      if (newVal !== this.localKeyword) {
        this.localKeyword = newVal || ''
      }
    }
  },
  methods: {
    handleInput (event) {
      this.localKeyword = event.target.value
      this.$emit('input', this.localKeyword)
    },
    emitSearch () {
      this.$emit('search', (this.localKeyword || '').trim())
    },
    selectSuggestion (word) {
      this.localKeyword = word
      this.$emit('input', word)
      this.emitSearch()
    },
    suggestionStyle (index) {
      const sizes = ['0.85rem', '0.95rem', '1.05rem', '1.2rem']
      const weights = [400, 500, 600]
      return {
        fontSize: sizes[index % sizes.length],
        fontWeight: weights[index % weights.length]
      }
    }
  }
}
</script>

<style scoped>
.search-bar {
  margin-top: 2em;
}

.search-form {
  display: flex;
  gap: 0.75em;
  align-items: center;
  max-width: 34em;
  margin: 0 auto;
  padding: 0.75em 1em;
  border: 1px solid #d5dbde;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.04);
}

.search-form input[type="search"] {
  flex: 1;
  padding: 0.25em 0.5em;
  border: none;
  font-size: 15px;
  background: transparent;
}

.search-form button {
  padding: 0.45em 1.5em;
  background: #fff;
  color: #4a4a4a;
  border: 1px solid #d5dbde;
  border-radius: 999px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.search-form input[type="search"]:focus,
.search-form button:focus {
  outline: none;
}

.search-form button:hover {
  background: #4a4a4a;
  color: #fff;
  border-color: #4a4a4a;
}

.search-suggestions {
  margin-top: 1.25em;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5em;
  justify-content: center;
}

.suggestion {
  border: none;
  border-radius: 999px;
  padding: 0.25em 0.9em;
  background: #f5f7fa;
  color: #4a4a4a;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.04);
}

.suggestion:hover {
  background: #e6ecf3;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.12);
}

.search-label {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
</style>
